<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{$t('Payment.CreditCardHeading')}}</h2>

      <div class="select-credit">
        <p class="select-credit-info"><input type="radio" name="credit" id="credit0" value="1" v-model="useCard" :checked="useCard === '1' || false" :disabled="!cardInfo.isSaved"><label for="credit0">{{$t('Payment.UseSaved')}}</label></p>
        <div>
          <div class="mod-form-block">
            <span class="label">{{$t('Payment.CardNumber')}}</span>
            <p class="regist-credit num">{{cardInfo.brand_name}} {{cardInfo.card_number}}</p>
          </div>
          <div class="mod-form-block">
            <span class="label">{{$t('General.Limit')}}</span>
            <p class="regist-credit expiration">{{cardInfo.expiration}}</p>
          </div>
        </div>
      </div>

      <div class="select-credit">
        <p class="select-credit-info"><input type="radio" name="credit" id="credit1" value="2" v-model="useCard" :checked="useCard === '2' || false"><label for="credit1">{{$t('Payment.UseNew')}}</label></p>
        <div class="mod-form-block">
          <span class="label">{{$t('Payment.CardNumber')}}</span>
          <input type="text" inputmode="numeric" name="" id="number" v-model="newCard.number">
          <span class="validation-error" v-if="errors.number !== null">{{errors.number}}</span>
        </div>
        <div class="mod-form-block">
          <span class="label">{{$t('General.Limit')}}</span>
          <div class="select-horizontal">
            <select name="" id="month" v-model="newCard.month">
              <option v-for="month in months" :key="month" :value="month">{{month}}</option>
            </select>
            <span class="connect">{{$t('General.Month')}}</span>
            <select name="" id="year" v-model="newCard.year">
              <option v-for="year in years" :key="year" :value="year">{{String(year).substring(2, 4)}}</option>
            </select>
            <span class="connect">{{$t('General.Year')}}</span>
          </div>
          <span class="validation-error" v-if="errors.month !== null">{{errors.month}}</span>
          <span class="validation-error" v-if="errors.year !== null">{{errors.year}}</span>
        </div>
        <div class="mod-form-block">
          <span class="label">{{$t('Payment.SecureCode')}}</span>
          <input type="text" inputmode="numeric" name="" id="secureCode" class="input-security" v-model="newCard.secureCode">
          <span class="validation-error" v-if="errors.secureCode !== null">{{errors.secureCode}}</span>
        </div>
      </div>

      <div class="mod-normal-box">
        <dl class="mod-horizontal-definition">
          <dt>{{$t('General.Total')}}</dt>
          <dd><strong>￥{{displayThousandsSeparator(getOrderDetail.totalPrice)}}</strong> {{getOrderDetail.taxType}}</dd>
        </dl>
      </div>

      <p class="mod-form-btn"><a href="#" class="btn-base btn-main" @click.prevent="fix">{{$t('General.Fix')}}</a></p>
      <p class="mod-form-btn btn-back"><input type="submit" :value="$t('General.Return')" class="btn-base btn-negative btn-quit" @click.prevent="execBack()"></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import ValidationMixin from '@/mixins/ValidationMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOInputCreditCard',
  mixins: [ CommonMixin, ValidationMixin, DisplayErrorMixin ],
  computed: {
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getOrderDetail () {
      return this.$store.getters.orderDetail
    }
  },
  data () {
    return {
      months: [],
      years: [],
      cardInfo: {
        isSaved: false,
        brand_name: null,
        card_number: null,
        expiration: null
      },
      useCard: '2', // 1=登録済みのカード、2=新しいカード
      newCard: {
        number: null,
        month: null,
        year: null,
        secureCode: null
      },
      errors: {
        number: null,
        month: null,
        year: null,
        secureCode: null
      }
    }
  },
  methods: {
    fix: async function (event) {
      // 初期化
      let saveCard = false

      if (this.useCard === '2') {
        // バリデーション処理
        let validate = this.validCreditCard(this.newCard, this.years)
        this.errors = validate.errors
        if (!validate.isValid) {
          return false
        }

        // ダイアログ
        if (sessionStorage.getItem('login') !== null) {
          saveCard = await window.commonConfirm(this.$i18n.t('Payment.SaveCard'))
        }
      }

      // コールバック内からの参照用
      let that = this
      // 入力されたカード情報をStoreに保持する
      let params = {
        save_card: null,
        expiration: null,
        token: null,
        token_key: null,
        order_id: this.getOrderDetail.orderId,
        display_item_info: [],
        number: null, // 表示用
        brandName: null // 表示用
      }

      // バックエンドに渡す商品名のリストを生成する
      for (var i = 0; i < this.getOrderDetail.items.length; i++) {
        params.display_item_info.push({ 'item_name': this.getOrderDetail.items[i].name })
      }

      if (this.useCard === '1') {
        // 登録済みカードを使う場合
        params.number = this.cardInfo.card_number
        params.brandName = this.cardInfo.brand_name
        // 確認画面へ遷移
        that.$router.push({
          name: 'ConfirmCreditCard',
          params
        })
      } else {
        this.setDisabledButton(true)

        // 新規カードを使う場合
        params.save_card = saveCard
        params.expiration = `${this.newCard.year}${this.newCard.month}`

        // トークン生成
        window.com_sbps_system.generateToken({
          merchantId: this.getSbpsSetting().merchantId,
          serviceId: this.getSbpsSetting().serviceId,
          ccNumber: this.newCard.number,
          ccExpiration: params.expiration,
          securityCode: this.newCard.secureCode
        }, function (response) {
          if (response.result === 'OK') {
            params.token = response.tokenResponse.token
            params.token_key = response.tokenResponse.tokenKey
            params.number = response.tokenResponse.maskedCcNumber
            params.brandName = that.getInternationalBrand(response.tokenResponse.cardBrandCode)
            params.expiration = response.tokenResponse.ccExpiration

            // 確認画面へ遷移
            that.$router.push({
              name: 'ConfirmCreditCard',
              params
            })
          } else {
            that.errorFromApp('ErrorMsg.ERR_101', response)
          }
          that.setDisabledButton(false)
        })
      }
    },
    // 戻るボタン
    execBack: function () {
      this.$router.push({ name: 'PaymentMethod' })
    },
    // 有効期限の月を生成する
    getLimitMonth: function () {
      for (var i = 1; i <= 12; i++) {
        if (i < 10) {
          this.months.push(`0${i}`)
        } else {
          this.months.push(String(i))
        }
      }
    },
    // 有効期限の年を生成する
    getLimitYear: function () {
      let now = new Date(this.getServerTime.replace(/-/g, '/'))
      // 当年
      let year = now.getFullYear()
      this.years.push(String(year))
      // +5年分の年を生成する
      for (var i = 1; i <= 10; i++) {
        this.years.push(String(year + i))
      }
    },
    // カード情報取得
    getCardInfo: function () {
      let that = this
      // ログイン状態を確認
      if (this.getLoginInfo().isLogin) {
        this.setDisabledButton(true)
        // 登録済みカードを取得する
        this.callApi('GetCardInfo',
          {}
        )
          .then((res) => {
            if (res.data.result) {
              that.cardInfo.brand_name = res.data.value.brand_name
              that.cardInfo.card_number = res.data.value.card_number
              that.cardInfo.expiration = res.data.value.expiration_date
              that.cardInfo.isSaved = res.data.value.brand_name !== '' || false
              that.useCard = res.data.value.brand_name !== '' ? '1' : '2'
            } else {
              that.errorFromApi(res.data.errorCode, res.data.error)
            }
          })
          .catch((error) => {
            that.errorFromAxios(error)
          })
          .finally(() => {
            that.setDisabledButton(false)
          })
      }
    }
  },
  beforeMount () {
    this.getLimitMonth()
    this.getLimitYear()
    this.getCardInfo()
  },
  mounted () {
    // 初期選択を設定
    this.newCard.month = this.months[0]
    this.newCard.year = this.years[0]
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.validation-error {
  color: #f00;
  display: block;
}
.mod-form-block p {
  min-height: 34px;
}
input[type="submit"] {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/InputCreditCard.vue